import { useReportCanonicalRumViewName } from '@ctw/shared/context/telemetry/use-rum-view-name';
import { ZapProvider } from '@ctw/shared/context/zap-context';
import { ZuiProvider } from '@ctw/shared/context/zui-provider';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router';
import ZAPV2 from './ZAP-v2';

const RouteDefinitions = () => {
  const location = useLocation();

  useReportCanonicalRumViewName(location.pathname);

  return (
    <ZuiProvider service="zap-sof" navigatePersistentQueryParams={['ehr']}>
      <ZapProvider>
        <Routes>
          <Route path="/zap-v2/*" element={<ZAPV2 />} />
        </Routes>
      </ZapProvider>
    </ZuiProvider>
  );
};

export function App() {
  return (
    <BrowserRouter>
      <RouteDefinitions />
    </BrowserRouter>
  );
}
